/**
 * getTableRow returns an object intended for usage in a generic table view. Currently, only
 * the asset table utilizes this functionality. Properties of this object prescribe the behaviour
 * of a particular header and all rows for that header.
 * 
 * For example, whether that column should be shown (show), or a handler for when a row is
 * clicked (valueOnClick).
 * 
 */
export function getTableRow(overrides = {}) {
  return {
      header: '',
      icon: false,
      headerIsClickable: false,
      valueIsClickable: false,
      value: (prop) => prop[`${overrides.header}`.toLowerCase()],
      show: () => true,
      headerOnClick: () => {},
      valueOnClick: () => {},
      getIcon: (prop) => undefined,
      getHeaderClass: () => '',
      getRowClass: () => '',
      sortable: () => false,
      sortIcon: () => undefined,
      ...overrides
  }
}